<template>
  <div id="app">
      <!-- <h1>{{msg}}</h1>
      <br>
      <br>
      <h2>{{wxopenid}}</h2> -->
  </div>
  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'app',
  data () {
    return {
      msg: 'test中 授权中……',
      wxcode:'',
      wxopenid:'',
      appid:'wx2b3aeba954d60a5b',
      appsecret:'161903be369bdf7550e65486b3b3b6e9'
    }
  },
  created(){
    this.wxcode= this.getUrlKey("code");
    if(this.wxcode){
        // 至此已获得code，开始换取openid
        this.getOpenid();

    }else{
        // 开始获取code
        this.getCodeApi();
    }
  },
  methods:{
    // 获取code   
    getCodeApi(){
       let urlNow=encodeURIComponent(window.location.href);
       // let scope='snsapi_userinfo';    //snsapi_userinfo snsapi_base   //静默授权 用户无感知
       //alert(window.location.href);
       let url= 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ this.appid+'&redirect_uri='+urlNow+'&response_type=code&scope=snsapi_base#wechat_redirect';
       window.location.href = url
    },
    getUrlKey:function(name){//获取url 参数
       return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },
    
    // 获取openid
    getOpenid(){        
        // 此处使用后台webapi换取openid
        this.msg=this.wxcode;
        var api='http://appointmentwebapixct.romis.cn/api/gxpenid';
        Axios.post(api,qs.stringify({
        'code':this.wxcode
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"}
        }).then(response=>{
            // 成功获取openid!            
            //alert('写入缓存:' + response.data.openid);
            // 缓存下openid
            localStorage.setItem('wxopenid',response.data.openid);
            // 跳转到预约首页
            this.$router.push({path:'/appointment'});
      }).catch(err=>{
          // this.msg=err;
          // 跳转到错误处理页面
          this.$router.push({path:'/err'});
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/authtest.vue